<template>
  <div>
    <v-layout align-center>
      <span class="title">
        Franchises – {{ workersNb }} workers in total
      </span>
      <v-spacer/>
      <v-btn
        icon
        class="ma-0"
        @click="dialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-progress-linear
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <template v-else>
      <v-divider/>
      <v-expansion-panel :value="franchises.length > 0 ? 0 : -1">
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="franchises"
            hide-actions>
            <template
              slot="items"
              slot-scope="props">
              <tr>
                <td>
                  <router-link
                    :to="{ name: 'franchise', params: { id: props.item.id } }"
                    class="clickable">{{ props.item.name }}</router-link>
                </td>
                <td>
                  <div>{{ props.item.details | filterPhone }}</div>
                  <div><em>{{ props.item.details | filterAddress }}</em></div>
                </td>
                <td class="text-xs-center">
                  {{ props.item.rating | displayRating }}
                </td>
              </tr>
            </template>
            <template slot="no-data"/>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
    <!-- NEW FRANCHISE DIALOG -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="50rem">
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex>
                <v-form v-model="valid">
                  <v-text-field
                    v-model="newFranchise.name"
                    :rules="[v => !!v || 'Name is required']"
                    label="Name"/>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="createFranchise">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "franchises-table",
  filters: {
    displayRating (rating) {
      return rating ? parseFloat(rating).toFixed(1) : "";
    },
    filterPhone (details) {
      let filtered = details.filter((d) => d.immutable === "phone");
      if (filtered.length > 0) {
        return filtered[0].value;
      }
      return "";
    },
    filterAddress (details) {
      let filtered = details.filter((d) => d.immutable === "address");
      if (filtered.length > 0) {
        return filtered[0].value;
      }
      return "";
    }
  },
  data () {
    return {
      dialog: false,
      franchises: [],
      headers: [
        {
          text: "Name",
          value: "name",
          width: ""
        },
        {
          text: "Contact",
          value: "address",
          sortable: false,
          width: "50%"
        },
        {
          text: "Rating",
          value: "rating",
          align: "center",
          width: "1%"
        }
      ],
      loading: false,
      newFranchise: { name: "" },
      posting: false,
      valid: false
    };
  },
  computed: {
    workersNb () {
      let sum = 0;
      this.franchises.forEach((f) => {
        sum += f.workers.length;
      });
      return sum;
    }
  },
  created () {
    // Get the subcontractor's franchises
    this.loading = true;
    this.$http.get(`/api/franchises?sub=${this.$route.params.id}`).
      then((r) => this.franchises = Array.from(r.data)).
      finally(() => this.loading = false);
  },
  methods: {
    createFranchise () {
      this.posting = true;
      this.$http.
        post("/api/franchises", {
          name: this.newFranchise.name,
          subcontractorId: this.$route.params.id
        }).
        then((r) => {
          this.$router.push({
            name: "franchise",
            params: { id: r.data.id }
          });
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractor/FranchisesTable.vue